module.exports = __webpack_public_path__ + "media/assets/images/settings_header-a448d54f74049dec6982237060a877de.jpg";